export default __webpack_public_path__ + "static/media/Parallax1.63e772e7.jpg";